import configs from '@/configs';
import {request_header, request_payload} from '@/commons/hpod';
import { handleUnauthorizedResponse } from '@/commons/auth';
import { sendErrorNotice } from '@/commons/utils';

export default {
    getPayOrderList(cb, $http, param, token) {
        const req = {
            headers: request_header(token)
        };
        const query = request_payload(param);
        return $http.get(`${configs.API}/admin/api/pay_order/${query}`, req).then(function (res) {
            setTimeout(() => cb(res.data), 100);
            return res.data;
        });
    },
    getPayOrderDetail(cb, $http, customerId, token) {
        const req = {
            headers: request_header(token)
        };
        return $http.get(`${configs.API}/admin/api/pay_order/${customerId}`, req).then(function (res) {
            setTimeout(() => cb(res.data), 100);
            return res.data;
        });
    },
    updatePayOrder(cb, $http, {order_ids, deposit_ids, cash, method, shipFee, feeOther, feeOtherName, customer_id, shippingMethod, Addresss, PhoneNumber, only_deliverable, ignore_vat_check}, token) {
        const header = {
            headers: request_header(token)
        };
        let req = _.cloneDeep({order_ids: order_ids.join(','), deposit_ids: deposit_ids.join(','), cash, method, shipFee, feeOther, feeOtherName, customer_id, shippingMethod, Addresss, PhoneNumber, only_deliverable, ignore_vat_check});
        return $http.post(`${configs.API}/admin/api/pay_order/${customer_id}`, req, header).then(function (res) {
            setTimeout(() => cb(res.data), 100);
            return res.data;
        },
        function (err) {
            if(err.status == 401) {
              handleUnauthorizedResponse(err);
            }
            else if(err.status == 406) {
              sendErrorNotice(err.data.reason);
            }
        });
    }
}
